import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import TextField from 'material-ui/TextField';
import moment from 'moment';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import KeyboardedInput from 'react-touch-screen-keyboard';
import 'react-touch-screen-keyboard/lib/Keyboard.css';
import * as actions from '../../actions/actions.jsx';
import s from '../../services/allservices.jsx';
import '../../stylesheet/virtualkeyboard.css';
import Loader from '../loader/loader.jsx';
import CardInfo from '../dashboard/cardlist'
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth.js'
import OtpPopup from '../otp/OtpPopup.js';
import { withRouter } from 'react-router-dom';
const styles = {
    stepbutton: {
        fill: "rgb(48, 86, 151)"
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    floatingLabelStyle: {
        fontSize: "18px",
        color: "#333"
    },
    underlineStyle: {
        borderBottom: '1px solid #333',
    }
}

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState
})
const mapDispatchToProps = dispatch =>
({
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    }
})

const JSEncrypt = window.JSEncrypt
class ManagePin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            oldPIN: "",
            value: '',
            newPIN: "",
            expiry: "",
            // yourDate: new Date(),
            //dateOfBirth: "" ,
            loader: true,
            correctpin: true,
            confirmPIN: "",
            cardDetailsId: "",
            disabled: true,
            selectedCard: [],
            selectedNewcard: [],
            pinValue: "",
            otpOpen: false,
            popupLoader: false,
            otp: "",
            toggleType: "password",
            toggleType1: "text",
            toggleText: "text",
            toggleText: "password",
            togglePINIcon: "fa fa-eye-slash",
            toggleConfirmPINIcon: "fa fa-eye-slash",
            pinError: "",
            confirmPinError: "",
            expiryError: "",
            customMapping: [

            ],
        }
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleDateOfBirth = this.handleDateOfBirth.bind(this);

    }
    componentDidMount() {

        const { publicKey } = this.props

        let _this = this
        setTimeout(function () {
            if (publicKey && publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);



    }
    onChange = (e, value) => this.setState({
        [e.target.name]: e.target.value
    }, () => {

    })
    handleChange = (e) => {

        this.setState({
            [e.target.name]: e.target.value
        }, () => {

        })
    }
    validatePinForm = () => {

        const {
            newPIN,
            confirmPIN,
            actualExpiryNumber
        } = this.state;

        let pinError = "";
        let confirmPinError = "";
        let expiryError = "";

        if (!newPIN) {
            pinError = "New PIN is required";
        } else if (!/^\d{4}$/.test(newPIN)) {
            pinError = "PIN must be 4 numbers";
        }

        if (!confirmPIN) {
            confirmPinError = "Confirm PIN is required";
        } else if (newPIN !== confirmPIN) {
            confirmPinError = "PIN and confirm PIN do not match!";
        }

        if (!actualExpiryNumber) {
            expiryError = "Card expiry is required";
        } else if (!/^\d{4}$/.test(actualExpiryNumber)) {
            expiryError = "Enter valid expiry date (MMYY)";
        }

        this.setState({
            pinError,
            confirmPinError,
            expiryError
        });
    };
    // for otp open


    otpPopupOpenModal = () => {
          const { actualExpiryNumber, selectedCard } = this.state;

   
    if (actualExpiryNumber !== selectedCard.expDate) {
        toast.error("Incorrect Expiry Date", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
        });
        return;
    }

        const otpValidation = localStorage.getItem('otpValidation');

        if (otpValidation === 'false') {
            // Skip OTP modal — call final API directly
            this.setState({ otp: "" }, () => {
                this.handleChangePin(null, null);
            });
        } else {
            // Show OTP modal as usual
            this.setState({
                otpOpen: true,
                popupLoader: false,
            }, () => {
                this.handleRequestOtp(false);
            });
        }
    };

    // for otp close
    otpPopupCloseModal = () => {
        this.setState({
            otpOpen: false,
        });
    };

    // OTP submit
    handleOtpSubmit = (otp, onSuccess, onError) => {

        this.setState({
            otp: otp,
            popupLoader: true,
        }, () => {

            this.handleChangePin(onSuccess, onError);

        });

    };

    handleChangePin = (onSuccess, onError) => {
        const { publicKey } = this.props
        const { newPIN, confirmPIN } = this.state




        this.setState({
            disabled: true
        })
        if (publicKey && publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);


            const state = {
                cardDetailsId: encrypt.encrypt(this.state.cardDetailsId),
                // oldPIN: encrypt.encrypt(this.state.oldPIN),
                pin: encrypt.encrypt(this.state.newPIN),
                expiryDate: encrypt.encrypt(this.state.actualExpiryNumber),
                otp: this.state.otp,
                // dob: encrypt.encrypt("14081979"),
                //dob: encrypt.encrypt(this.state.dateOfBirth),
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',

            }

            // if (oldPIN.length == 4) {
            if (newPIN.length === 4) {
                if (confirmPIN.length === 4) {
                    let token = "Token " + localStorage.getItem('token')

                    if (newPIN === confirmPIN) {
                        // if (oldPIN !== newPIN) {
                        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                        let traceId = getClientId();
                        fetch(plink + s.change_pin, {
                            method: 'POST',
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': token,
                                'X-Trace-Id': traceId,
                                'X-Client-APP': buildClientHeader(),

                            }),
                            body: JSON.stringify(state)
                        })
                            .then(response => {
                                if (response.status === 200 || response.status === 201 || response.status === 204) {
                                    toast.success(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    });
                                    this.setState({
                                        popupLoader: false,
                                        loader: true
                                    }, () => {

                                        setTimeout(() => {

                                            this.setState({
                                                loader: false
                                            });

                                            window.location.reload(true);

                                        }, 3000);

                                    });

                                }
                                else if (response.status === 401) {

                                    this.setState({
                                        popupLoader: false,
                                        loader: false
                                    });

                                    if (this.props.history !== undefined) {
                                        this.props.history.push('/sessionout')
                                    }

                                }
                                else if (response.status === 422) {

                                    this.setState({
                                        popupLoader: false,
                                        loader: false,
                                    });
                                    if (onError) {
                                        onError(response.headers.get('message'));
                                    }
                                    let message = response.headers.get("message");

                                    //   response.json().then((json) => {
                                    //   message = json.message
                                    //       ? json.message
                                    //       : response.headers.get("message");

                                    toast.error(message, {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        draggablePercent: 60,
                                    });
                                    //   });

                                    // toast.error(message, {
                                    //     position: "top-right",
                                    //     autoClose: 3000,
                                    //     hideProgressBar: false,
                                    //     closeOnClick: true,
                                    //     pauseOnHover: true,
                                    //     draggable: true,
                                    //     draggablePercent: 60,
                                    // });

                                }
                                else if (response.status === 412) {
                                    this.setState({
                                        popupLoader: false,
                                        loader: false
                                    }, () => {

                                        if (onError) {
                                            onError(response.headers.get('message'));
                                        }

                                    });
                                    response.json()
                                        .then(json => {
                                            let message = json.shortMessage ? json.shortMessage : response.headers.get('message')
                                            //document.getElementById('setpassword').style.display = "block"
                                            toast.error(message, {
                                                position: "top-right",
                                                autoClose: 3000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true,
                                                draggablePercent: 60
                                            })
                                        })

                                }
                                else {
                                    this.setState({
                                        popupLoader: false,
                                        loader: false
                                    }, () => {

                                        if (onError) {
                                            onError(response.headers.get('message'));
                                        }

                                    });
                                    toast.error(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    });



                                }
                            })
                        // }
                        //  else {
                        //     toast.error('Old PIN should not be same as New Pin'), {
                        //         position: "top-right",
                        //         draggablePercent: 60,
                        //         autoClose: 3000,
                        //         hideProgressBar: false,
                        //         closeOnClick: true,
                        //         pauseOnHover: true,
                        //         draggable: false
                        //     };

                        // }
                        // setTimeout(function () {
                        //     window.location.reload(1);
                        // }, 3000);
                    } else {
                        // eslint-disable-next-line
                        this.setState({
                            popupLoader: false,
                            loader: false
                        }, () => {

                            if (onError) {
                                onError('New PIN and Confirm PIN should be the same');
                            }

                        });
                        toast.error('New PIN and Confirm PIN should be the same'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        };
                        // setTimeout(function () {
                        //     window.location.reload(1);
                        // }, 3000);
                    }
                } else {
                    // eslint-disable-next-line
                    this.setState({
                        popupLoader: false,
                        loader: false
                    }, () => {

                        if (onError) {
                            onError('Confirm PIN Should Be 4 Digits');
                        }

                    });
                    toast.error('Confirm PIN Should Be 4 Digits'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };

                }
            } else {
                // eslint-disable-next-line
                this.setState({
                    popupLoader: false,
                    loader: false
                }, () => {

                    if (onError) {
                        onError('New PIN Should Be 4 Digits');
                    }

                });
                toast.error('New PIN Should Be 4 Digits .'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                };

            }
        }
        // else {
        //     toast.error('Old PIN should be 4 digits .'), {
        //         position: "top-right",
        //         draggablePercent: 60,
        //         autoClose: 3000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: false
        //     };

        // }
        // }
    }

    componentWillReceiveProps(nextProps) {



        this.setState({
            loader: true
        })
        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {

                var filteredG = nextProps.cardState.body.filter((val) => {
                    return (val.cardType === "G")
                })

                var filteredR = nextProps.cardState.body.filter((val) => {
                    return (val.cardType === "R")
                })
                var filteredCards = filteredR.concat(filteredG)



                this.setState({
                    loader: false,
                    cardDetailsId: filteredCards[0].cardDetailsId,
                    selectedCard: filteredCards[0],
                    selectedNewCard: [filteredCards[0]],
                    filteredCards: filteredCards
                }, () => {


                })
            }
        } catch (e) {

        }
    }

    handleDOB(e) {

        let string = e.target.value;
        const dob = string.replace(/\//g, "");
        const actualdob = dob.replace(/_/g, "");

        if (this.state.newPIN !== "" && this.state.confirmPIN !== "" && this.state.expiry !== "" && (actualdob.length >= 8)) {
            this.setState({
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
    }

    onChangeExpiry(e) {
        const { name } = e.target
        let string = e.target.value;
        this.setState({ [name]: e.target.value }
            , () => {
                const expiryNumber = string.replace(/\//g, "");
                const actualExpiryNumber = expiryNumber.replace(/_/g, "");

                if (this.state.newPIN !== "" && this.state.confirmPIN !== "" && actualExpiryNumber.length >= 4) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            });


    }

  
    handleValueChangenew = (e) => {

        const value = e.target.value.replace(/\D/g, "");

        if (value.length <= 4) {
            this.setState({
                newPIN: value
            }, () => {
                this.validatePinForm();
            });
        }
    };
    handleValueChange = (e) => {

        const value = e.target.value.replace(/\D/g, "");

        if (value.length <= 4) {
            this.setState({
                confirmPIN: value
            }, () => {
                this.validatePinForm();
            });
        }
    };
    handleExpiryChange = (e) => {

        const value = e.target.value.replace(/\D/g, "");

        if (value.length <= 4) {
            this.setState({
                actualExpiryNumber: value
            }, () => {
                this.validatePinForm();
            });
        }
    };

    handleValueConfirm(val) {


        if (this.state.confirmPIN.includes("_")) {


            this.setState({
                toggleText: "text",
                confirmPinError: true,

                // PinMatchecdError: false
                // pin: val
                // NextBtndisabled: false,

            })
        } else {
            this.setState({
                // pinError: true,


                toggleText: "password",
                confirmPinError: false,
                // PinMatchecdError: true,
                // NextBtndisabled: true,

            })
        }




    }




    removepin = () => {
        this.setState({
            correctpin: true
        })
    }
    handleValueChangeold(val) {
        if (val.length <= 4) {
            this.setState({ oldPIN: val }
                , () => {
                    if (this.state.newPIN !== "" && this.state.confirmPIN !== "" && this.state.expiry !== "") {
                        this.setState({
                            disabled: false
                        })
                    }
                    else {
                        this.setState({
                            disabled: true
                        })
                    }
                });
        }
    }
    handleValue(val) {




        if (this.state.newPIN.includes('_')) {


            this.setState({


                pinError: true,
                toggleType1: "text"

                // confirmPinError: false,
                // PinMatchecdError: false
                // pin: val
                // NextBtndisabled: false,

            })
        } else {
            this.setState({
                pinError: false,
                toggleType1: "password"
                // confirmPinError: true,
                // PinMatchecdError: true,
                // NextBtndisabled: true,

            })
        }




    }

    handleSelect1 = (event, index, value) => {

        const { filteredCards } = this.state
        this.setState({ cardDetailsId: value }, () => {
            for (let i = 0; i < filteredCards.length; i++) {
                if (this.state.cardDetailsId === filteredCards[i].cardDetailsId) {

                    this.setState({

                        selectedCard: filteredCards[i],
                        selectedNewCard: [filteredCards[i]],
                        cardState: filteredCards[i]
                    })
                }
            }
        });

    }
    handleRequestOtp = (isResend = false) => {

        let token = "Token " + localStorage.getItem("token");

        const { publicKey } = this.props;

        const public_Key = publicKey.body.publickey;

        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(public_Key);

        let state = {
            // userName: this.state.userName,
            cardDetailsId: encrypt.encrypt(this.state.cardDetailsId),
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'

        };
        if (isResend) {
            state.reSendOtp = true;
        }

        let plink =
            localStorage.getItem("pform") === "AU"
                ? process.env.REACT_APP_SERVICEURL_AU
                : process.env.REACT_APP_SERVICEURL_NZ;

        let gid = getClientId();
        let traceId = getClientId();

        fetch(plink + s.otp_change_pin, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: token,
                clientId: gid,
                clientSecret: getClientSecret(gid, this.state.applicationId),
                "X-Trace-Id": traceId,
                "X-Client-APP": buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then((response) => {

                if (
                    response.status === 200 ||
                    response.status === 201 ||
                    response.status === 204
                ) {



                    toast.success(response.headers.get("message"), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                    });

                }
                else if (response.status === 401) {

                    if (this.props.history !== undefined) {
                        this.props.history.push('/sessionout')
                    }

                }
                else {



                    toast.error(response.headers.get("message"), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                    });
                }
            });

    };

    checkSubmit() {
        if (this.state.newPIN !== "" && this.state.confirmPIN !== "" && this.state.expiry !== "") {
            this.setState({
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
    }

    handleDateOfBirth(e) {
        //let valid_date = new Date(e.target.value)
        let valid_date = e.target.value


        if (moment(valid_date, "DD/MM/YYYY", true).isValid()) {
            const split = valid_date.split('/');
            let day = split[0];
            let month = split[1];
            let year = split[2];

            console.log('day', split[0])
            console.log('month', split[1])
            console.log('year', split[2])

            //console.log("fulldate in yyyy-mm-dd" , [year, month, day].join('-') );
            //console.log("fulldate in dd-mm-yyyy" , [day, month, year].join('-') );
            //let formattedDate_dmy = [day, month, year].join('');


            let finalDate = `${day}${month}${year}`;

            //let newdate =  moment(formattedDate_dmy, "dd-mm-yyyy");
            //console.log( " newdate " , newdate)
            //let formattedDate = new Date().toLocaleDateString(new Date(newdate), "dd-mm-yyyy")

            //console.log("newdates month " , newdate.month()+1);

            console.log("Formattted dmy ", finalDate);
            this.checkSubmit();
            this.setState({
                dateOfBirth: finalDate,
            }, function () {
                console.log("Date of Birth Final ", this.state.dateOfBirth);
            });
        }
    }

    handleBirthDate = (dateOfBirth, date) => {
        var month3;
        var date3;
        console.log("Date  :", date)
        let year = new Date(date).getFullYear()
        let month = new Date(date).getMonth() + 1
        if (month > 0 && month < 10) {
            month3 = "0" + month
        }
        else {
            month3 = month
        }
        let date1 = new Date(date).getDate()
        if (date1 > 0 && date1 < 10) {
            date3 = "0" + date1
        }
        else {
            date3 = date1
        }
        let finalDate = `${date3}${month3}${year}`
        //console.log("handlebirthdate finaldate" , finalDate)
        // console.log("year : " , year)
        // console.log("month : " , month)

        this.setState({
            dobVerified: true,
            dobRederFeedback: false,
        })
        this.setState({
            dateOfBirth: finalDate
        }
            , () => {
                if (this.state.newPIN !== "" && this.state.confirmPIN !== "" && this.state.expiry !== "" && this.state.dateOfBirth !== undefined) {
                    this.setState({
                        disabled: false

                    })
                }
                else {
                    this.setState({
                        disabled: true
                    })
                }
            });

    }

    togglePIN = () => {

        if (this.state.toggleType1 === "password") {
            this.setState({
                toggleType1: "text",
                togglePINIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleType1: "password",
                togglePINIcon: "fa fa-eye-slash"
            })
        }
    }

    toggleConfirmPIN = () => {
        if (this.state.toggleText === "password") {
            this.setState({
                toggleText: "text",
                toggleConfirmPINIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleText: "password",
                toggleConfirmPINIcon: "fa fa-eye-slash"
            })
        }
    }

    formatDate = (date) => {
        let finalDate;
        let finalMonth;

        let getDate1 = date.getDate()
        if (getDate1 > 0 && getDate1 < 10) {
            finalDate = "0" + getDate1
        }
        else {
            finalDate = getDate1
        }

        let getMonth1 = date.getMonth() + 1

        if (getMonth1 > 0 && getMonth1 < 10) {
            finalMonth = "0" + getMonth1
        }
        else {
            finalMonth = getMonth1
        }



        return finalDate + "-" + finalMonth + "-" + date.getFullYear();
    }

    // When the user clicks on the password field, show the message box
    handleClick() {
        document.getElementById("numberpad").style.display = "block"
    }
    validatepin = (e) => {

    }
    render() {

        const { cardState } = this.props

        const { cardDetailsId, selectedCard, correctpin, filteredCards } = this.state

        const isPinFormValid =
            this.state.newPIN &&
            this.state.confirmPIN &&
            this.state.actualExpiryNumber &&
            !this.state.pinError &&
            !this.state.confirmPinError &&
            !this.state.expiryError;

        return (

            <div style={{}}>
                {this.state.otpOpen && (

                    <OtpPopup
                        open={this.state.otpOpen}
                        onClose={this.otpPopupCloseModal}
                        handleRequestOtp={this.handleRequestOtp}
                        onSubmit={this.handleOtpSubmit}
                        loading={this.state.popupLoader}
                    />
                )}

                <div className="col-md-12 top-header text-left" style={{ marginBottom: "10px" }}>
                    <div className="header-style" style={{}}>
                        <h4 className='logmainheading mainheading'>
                            Change PIN
                        </h4>
                        {/* <p>Changing your card PIN is easy. Fields marked with an * must be filled.</p>
                        <span>To help protect your security, the keyboard entry has been disabled. Please use the on-screen keypad to enter your card PIN. Click on the respective field to launch the on-screen keypad.</span> */}
                        {/* <br/><br/> */}
                    </div>

                </div>

                {cardState.status === 200 && cardState.body.length !== 0
                    //  && selectedCard.length !== 0 && filteredCards.length !== 0 
                    ?
                    <div className="card-account">
                        <div className="row">
                            <div className="col-md-4">

                                <div className="pl-3 pt-2" >
                                    <SelectField
                                        floatingLabelText=""
                                        onChange={this.handleSelect1}
                                        className="input-width"
                                        name="Selected Card"
                                        style={{ marginTop: -12 }}
                                        autoComplete='none'
                                        value={cardDetailsId}>
                                        {/* {filteredCards.map((value, i) =>
                                        <MenuItem value={filteredCards[i].cardDetailsId} primaryText={filteredCards[i].cardNumber} key={i} />
                                    )} */}
                                        {cardState.body.map((value, i) =>
                                            <MenuItem className='menuitem' value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                        )}
                                    </SelectField>
                                </div>

                          
                            </div>
                        </div>

                    </div>
                    : <Loader />

                }
                <div className="col-sm-12 p-0 m-0 fixedparent">

                    <CardInfo
                        selectedNewCard={this.state.selectedNewCard} />

                </div>
                <div className="change-pin">


                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-md-12" style={{ padding: "0px 15px" }}>


                                <div className="top-header text-left" style={{ fontWeight: "600" }}>
                                    Change PIN Details
                                </div>


                            </div>
                            <div className="col-md-12 col-sm-12" style={{ marginTop: '20px', padding: "0px 15px" }}>
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <div className="row">
                                         


                                            <div className="col-md-12 col-sm-12">
                                                <div className="row">
                                                    <div className=" col-md-12 col-sm-12">
                                                        <div className="row input-group" >
                                                            {/* <div className="col-sm-2 passwordinput" >
                                                                <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                                            </div> */}
                                                            <div className="col-sm-5" >

                                                                {/* <KeyboardedInput

                                                                        type={this.state.toggleType}
                                                                        value={this.state.newPIN}
                                                                        onChange={(value) => { this.handleValueChangenew(value); }}
                                                                        enabled
                                                                        name={"newPIN"}
                                                                        opacity={1}
                                                                        className="required"
                                                                        defaultKeyboard={this.state.customMapping}
                                                                        placeholder={'Enter New 4 Digits PIN'}
                                                                        step={4}
                                                                        isDraggable={false}
                                                                        onBlur={this.removepin}
                                                                        errorText={correctpin ? null : "Should contain 4 digits."}

                                                                    /> */}


                                                                <div className="group">
                                                                    <InputMask mask="9999" maskchar="*" type={this.state.toggleType1} value={this.state.pin} name="newPIN"
                                                                        // onChange={(event, value) => { this.handleValueChangenew(event, value) }}
                                                                        onChange={(event, value) => {
                                                                            this.handleValueChangenew(event, value)
                                                                        }}
                                                                        onBlur={(value) => { this.handleValue(value); }}
                                                                    />
                                                                    <span className="highlight"></span>
                                                                    <span className="bar"></span>
                                                                    {this.state.pinError && (
                                                                        <div
                                                                            style={{
                                                                                color: "#d32f2f",
                                                                                fontSize: "12px",
                                                                                marginTop: "5px"
                                                                            }}
                                                                        >
                                                                            {this.state.pinError}
                                                                        </div>
                                                                    )}
                                                                    <label className='simsfont '>New PIN<span style={{ color: "#e32", fontSize: "18px" }}> *</span> </label>
                                                                </div>
                                                                {/* <span toggle="#pin" className={`simsfont ${this.state.togglePINIcon} field-icon toggle-password`} style={{ float: "right", right: "10px", position: "absolute", top: "40px", cursor: "pointer" }} onClick={this.togglePIN} ></span> */}
                                                                <span toggle="#newpin" className={`${this.state.togglePINIcon} field-icon toggle-password`} style={{ float: "right", right: "15px", position: "absolute", top: "35px", cursor: "pointer" }} onClick={this.togglePIN} ></span>
                                                                <div id="errornew">Should contain maximum 4 digits.</div>
                                                            </div>


                                                            <div className="col-sm-5" >

                                                                {/* <KeyboardedInput
                                                                        type={this.state.toggleText}
                                                                        value={this.state.confirmPIN}
                                                                        onChange={(value) => { this.handleValueChange(value); }}
                                                                        enabled
                                                                        name={"confirmPIN"}
                                                                        opacity={1}
                                                                        className="required"
                                                                        defaultKeyboard={this.state.customMapping}
                                                                        placeholder={'Confirm Your PIN'}
                                                                        step={4}
                                                                        isDraggable={false}
                                                                    /> */}

                                                                <div className="group" >
                                                                    <InputMask mask="9999" maskchar="*" type={this.state.toggleText} value={this.state.confirmPin} name="confirmPIN" 
                                                                    // onChange={(e, value) => { this.handleValueChange(e, value);

                                                                    //  }}
                                                                        // onBlur={(e, value) => { this.handleValueConfirm(e, value); }}
                                                                        onChange={(event, value) => {
                                                                            this.handleValueChange(event, value)
                                                                        }}

                                                                    />
                                                                    <span className="highlight"></span>
                                                                    <span className="bar"></span>
                                                                    {this.state.confirmPinError && (
                                                                        <div
                                                                            style={{
                                                                                color: "#d32f2f",
                                                                                fontSize: "12px",
                                                                                marginTop: "5px"
                                                                            }}
                                                                        >
                                                                            {this.state.confirmPinError}
                                                                        </div>
                                                                    )}
                                                                    <label className='simsfont'>Confirm New PIN <span style={{ color: "#e32", fontSize: "18px" }}> *</span></label>
                                                                </div>
                                                                <span toggle="#cofirmpin" className={`${this.state.toggleConfirmPINIcon} field-icon toggle-password`} style={{ float: "right", right: "10px", position: "absolute", top: "40px", cursor: "pointer" }} onClick={this.toggleConfirmPIN} ></span>
                                                                {/* {confirmPinError && errorDiv} */}
                                                                <div id="errorconfirm">Should contain maximum 4 digits.</div>
                                                            </div>
                                                            {/* <span toggle="#confpin" className={`${this.state.toggleConfirmPINIcon} field-icon toggle-password`} style={{ float: "right", right: "1px", position: "absolute", top: "15px", cursor: "pointer" }} onClick={this.toggleConfirmPIN} ></span> */}
                                                            {/* <InputMask type="password"
                                                                            name="confirmPIN"
                                                                            placeholder="Confirm Your Pin"
                                                                            onChange={this.onChange}
                                                                            maskChar="" /> */}
                                                            {/* <div id="errorconfirm">Should contain maximum 4 digits.</div> */}



                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            <div className="col-md-12 col-sm-12">
                                                <div className="row">
                                                    <div className="col-md-12  col-sm-12" style={{ zIndex: "0" }}>
                                                        <div className="row input-group" >
                                                            {/* <div className="col-sm-1 group-icon">
                                                                <i className="fa fa-calendar text-dark " aria-hidden="true" ></i>
                                                            </div> */}
                                                            <div className="col-sm-5" style={{}}>
                                                                <div className="group">
                                                                    <InputMask mask="99/99"
                                                                        name="expiry"
                                                                        id="expiry"
                                                                        ref="item"
                                                                        // onChange={this.onChangeExpiry.bind(this)}
                                                                        onChange={(event, value) => {
                                                                            this.handleExpiryChange(event, value)
                                                                        }}
                                                                        placeholder="MM/YY"
                                                                        onBlur={this.handleExpiryChange.bind(this)}

                                                                        // disabled={this.state.exipryField}
                                                                        defaultValue={this.state.actualExpiryNumber}
                                                                    />
                                                                    <span className="highlight"></span>
                                                                    <span className="bar"></span>
                                                                    {this.state.expiryError && (
                                                                        <div
                                                                            style={{
                                                                                color: "#d32f2f",
                                                                                fontSize: "12px",
                                                                                marginTop: "5px"
                                                                            }}
                                                                        >
                                                                            {this.state.expiryError}
                                                                        </div>
                                                                    )}
                                                                    <label className='simsfont '>Card Expiry Date<span style={{ color: "#e32", fontSize: "18px" }}> *</span></label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-5" style={{}}>
                                                            

                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                         
                                        </div>
                                    </div>

                              

                                </div>
                            </div>
                            <div className=" col-sm-3 mb-5">
                             
                                <div className=" col-sm-3 mb-5">
                                    <RaisedButton
                                        label="Change"
                                        // disabled={this.state.disabled}
                                        disabled={!isPinFormValid}
                                        onClick={this.otpPopupOpenModal}
                                        className="btn-std"
                                        backgroundColor="#FFCE39"
                                        labelColor="#115876"
                                        style={{ minWidth: "50px", marginTop: "20px", borderRadius: "6px" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}
ManagePin.defaultProps = {
    cardState: {
        status: 600
    }
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ManagePin)
);


// WEBPACK FOOTER //
// ./src/components/myprofile/managepin.jsx